import { useQuery, useMutation, useQueryClient } from 'react-query';
import { updateImage } from '../queries/updateImage';
import SEPlayApi from '../SEPlayApi';

export function getOrderImages(orderId, reference: string) {
    return SEPlayApi.getOrderImages(orderId, reference);
}

export const useOrderImages = (orderId, imageGalleryReference) => {
    return useQuery(['images', imageGalleryReference], () =>
        getOrderImages(orderId, imageGalleryReference)
    );
};

export const useRemoveImage = () => {
    const queryClient = useQueryClient();
    return useMutation(updateImage, {
        onSuccess: () => {
            return queryClient.invalidateQueries('images');
        },
        onError: () => { }
    });
};
